{
  "layout": {
    "breadcrumb": "Account",
    "title": "Profile",
    "tabs": {
      "profile": "Profile",
      "security": "Security",
      "mcp": "MCP keys"
    }
  },
  "profile": {
    "personalHeading": "Personal details",
    "personalHint": "Colleagues see your name and email in the member list, project teams and emails.",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "emailConfirmed": "confirmed",
    "emailPending": "pending confirmation",
    "emailHint": "Changing the address sends a confirmation email. Until you confirm, sign-in and emails stay on the current one.",
    "pendingNotice": "We sent a link to <b>{{pending}}</b>. Until you confirm, sign-in and notifications use <b>{{email}}</b>.",
    "resend": "Resend",
    "cancelChange": "Cancel change",
    "passwordConfirmTitle": "Confirm email change",
    "passwordConfirmMessage": "Enter your current password to change your sign-in address to {{email}}.",
    "currentPassword": "Current password",
    "interfaceHeading": "Interface",
    "interfaceHint": "Saved to your account and applied on all devices.",
    "language": "Language",
    "languageRu": "Русский",
    "languageEn": "English",
    "theme": "Theme",
    "themeDark": "Dark",
    "themeLight": "Light",
    "save": "Save",
    "saving": "Saving…",
    "cancel": "Cancel"
  },
  "security": {
    "passwordHeading": "Password",
    "passwordHint": "At least 8 characters. Your current password is required.",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "newPasswordPlaceholder": "At least 8 characters",
    "confirmPassword": "Repeat new password",
    "confirmPasswordPlaceholder": "Once more",
    "passwordEffect": "Changing the password signs out other devices and revokes Claude Desktop sessions; API keys are on the MCP keys tab.",
    "changePassword": "Change password",
    "changingPassword": "Changing…",
    "sessionsHeading": "Devices and sessions",
    "sessionsHint": "Signs you out everywhere except this device. Password reset links sent earlier stop working too.",
    "signOutEverywhere": "Sign out everywhere",
    "signOutConfirmTitle": "Sign out everywhere?",
    "signOutConfirmMessage": "Sessions on other devices and in Claude Desktop will end, and earlier password reset links will stop working.",
    "signOutConfirmNote": "This device stays signed in. API keys keep working.",
    "signOutConfirmLabel": "Sign out everywhere"
  },
  "mcp": {
    "connectorHeading": "Claude Desktop",
    "connectorHint": "Connects with this address and your Frameriver login. No key needed.",
    "copyUrl": "Copy",
    "cliHeading": "Claude Code and API keys",
    "cliHint": "A key has the same access as your login and is sent in the Authorization header. Changing your password does not revoke keys — revoke them here.",
    "plaintextHeading": "Copy this key now",
    "plaintextHint": "This is the only time the full key is shown. Store it in Claude and do not share it.",
    "copyToken": "Copy key",
    "copied": "Copied",
    "copyFailed": "Could not copy",
    "namePlaceholder": "Key name, for example Claude Code",
    "create": "Create key",
    "creating": "Creating…",
    "createHint": "The key value is shown once, right after it is created.",
    "tokensHeading": "Keys",
    "empty": "No keys yet.",
    "createdAt": "Created {{date}}",
    "lastUsed": "Last used {{date}}",
    "expiresAt": "Expires {{date}}",
    "revoke": "Revoke",
    "revokeConfirm": "Revoke “{{name}}”? Claude will stop working until you create a new key.",
    "revoked": "Revoked",
    "expired": "Expired",
    "oauthHeading": "Claude Desktop sessions",
    "oauthEmpty": "No active sessions. They appear here after the first connection and are revoked with a button or when you change your password.",
    "oauthUnknownClient": "Unknown app",
    "oauthRevokeConfirm": "Revoke the session for “{{name}}”? Claude Desktop will need to sign in again.",
    "consent": {
      "title": "Allow access",
      "eyebrow": "Claude / MCP",
      "heading": "Allow {{client}} to access Frame River?",
      "subtitle": "{{client}} will act as {{email}} — the same projects and rights as this login.",
      "redirectLabel": "Redirects to",
      "unknownApp": "Unknown app",
      "allow": "Allow",
      "allowing": "Allowing…",
      "deny": "Deny",
      "denying": "Denying…"
    }
  }
}
